<template>
  <div>
    <shop-head currentPageName="qpjnh"></shop-head>
    <!-- 面包屑 -->
    <!-- 主要内容 -->
    <div class="content_wrapper">
      <div class="container">
        <!-- <breadcrumb pageName="汽配嘉年华"></breadcrumb> -->
        <el-row :gutter="0">
          <el-col :span="24" :offset="0">
            <div class="head">
              <img
                v-if="activelist[0].image"
                :src="activelist[0].image"
                style="
                  width: 100%;
                  height: 490px;
                  object-fit: fill;
                  position: absolute;
                  top: 0;
                "
              />
              <img
                src="../../assets/images/汽配嘉年华.png"
                alt=""
                style="width: 100%"
              />
              <div class="head-enter">
                <div>
                  <i class="el-icon-s-custom"></i>{{ $t("展商入口") }} >
                </div>
                <div
                  @click="() => this.$router.push({ name: 'booking' })"
                  style="background-color: #16a753"
                >
                  <i class="el-icon-user"> </i> {{ $t("观众入口") }} >
                </div>
                <div style="background-color: #f4f4f4"></div>
              </div>
            </div>
          </el-col>
        </el-row>
        <br />
        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <video
              controls
              src="https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh1fbe7795cfc74c4b9e58ae06eb07c6d5%E5%B9%BF%E5%9B%AD%E6%B1%87.mp4"
              width="500px"
              height="240px"
            ></video>
          </el-col>
          <el-col :span="12" :offset="0">
            <h1 style="color: #1b2d71; font-weight: 600">
              {{ $t("展会概况") }}
            </h1>
            <p>
              {{ activelist[0].content }}
            </p>
            <el-button
              v-if="!detailsVisable"
              type=""
              size="default"
              @click="detailsVisable = true"
              >{{ $t("查看详情") }}></el-button
            >
            <div v-if="detailsVisable">
              <span
                >{{ $t("参加人数") }}: {{ activelist[0].bookingNum
                }}{{ $t("人") }}</span
              >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span
                >{{ $t("活动时间") }}:
                {{ activelist[0].startTime | formatDate }} ~
                {{ activelist[0].endTime | formatDate }}</span
              >
            </div>
          </el-col>
        </el-row>
        <br />
        <h1>{{ $t("展商登记") }}</h1>
        <br />
        <el-tabs type="card">
          <el-tab-pane :label="$t('展商登记')">
            <el-form
              :model="form"
              ref="form"
              :rules="rules"
              label-width="130px"
              :inline="false"
              size="normal"
            >
              <el-row :gutter="20">
                <el-col :span="12" :offset="0">
                  <el-form-item :label="$t('联系人') + ':'" prop="name">
                    <el-input v-model="form.name"></el-input> </el-form-item
                ></el-col>
                <el-col :span="6" :offset="0">
                  <el-form-item :label="$t('称谓') + ':'" prop="personType">
                    <el-radio-group v-model="form.personType">
                      <el-radio :label="1">{{ $t("先生") }}</el-radio>
                      <el-radio :label="2">{{ $t("女士") }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="6" :offset="0">
                  <el-form-item :label="$t('职务') + ':'" prop="personJob">
                    <el-input v-model="form.personJob"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12" :offset="0">
                  <el-form-item
                    :label="$t('公司名称') + ':'"
                    prop="companyName"
                  >
                    <el-input v-model="form.companyName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" :offset="0">
                  <el-form-item
                    :label="$t('公司类型') + ':'"
                    label-width="130px"
                    prop="companyType"
                  >
                    <el-select v-model="form.companyType" placeholder="">
                      <el-option
                        v-for="item in companyTypes"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="12" :offset="0">
                                    <el-form-item label="职务: " prop="personJob">
                                        <el-input v-model="form.personJob"></el-input>
                                    </el-form-item>
                                </el-col> -->
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12" :offset="0">
                  <el-form-item :label="$t('手机') + ':'" prop="phone">
                    <el-input v-model="form.phone"></el-input> </el-form-item
                ></el-col>
                <el-col :span="12" :offset="0">
                  <el-form-item :label="$t('E-mail') + ':'" prop="email">
                    <el-input v-model="form.email"></el-input> </el-form-item
                ></el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12" :offset="0">
                  <el-form-item :label="$t('电话') + ':'" prop="tel">
                    <el-input v-model="form.tel"></el-input> </el-form-item
                ></el-col>
                <el-col :span="12" :offset="0">
                  <el-form-item :label="$t('网址') + ':'" prop="url">
                    <el-input v-model="form.url"></el-input> </el-form-item
                ></el-col>
              </el-row>
              <el-form-item
                :label="$t('感兴趣的展区') + ':'"
                :label-width="labelWidth"
                prop="interestedIds"
              >
                <el-checkbox-group
                  v-model="interestedIds"
                  @change="interestedIdsChange"
                >
                  <el-checkbox :label="$t('工厂零部件专区。')"></el-checkbox>
                  <br />
                  <el-checkbox :label="$t('车型品牌配件专区。')"></el-checkbox>
                  <br />
                  <el-checkbox :label="$t('新能源配件展区。')"></el-checkbox>
                  <br />
                  <el-checkbox
                    :label="$t('汽车后市场数字化专区。')"
                  ></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <!-- <el-form-item label="验证码: ">
                                <el-input></el-input>
                            </el-form-item> -->
              <el-form-item>
                <el-button type="primary" @click="onSubmit">{{
                  $t("提交申请")
                }}</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <!-- <el-tab-pane label="参展费用">

                    </el-tab-pane> -->
        </el-tabs>
      </div>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
import shopHead from "../../components/shop/head";
import commonFooter from "../../components/common/footer";
import breadcrumb from "../../components/common/breadcrumb";
import { subapply, activelist } from "../../apis/qpjnh";
export default {
  components: {
    shopHead,
    commonFooter,
    breadcrumb,
  },
  computed: {
    labelWidth() {
      return localStorage.getItem("language") === "zh" ? "130px" : "220px";
    },
  },
  filters: {
    formatDate(time) {
      return time ? new Date(time).toLocaleString().replaceAll("/", "-") : "--";
    },
  },
  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 10,
      detailsVisable: false,
      activelist: [{}],
      form: {
        activityInfoId: "0450b11f62b040289f97f4ad18168475",
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$i18n.t("联系人"),
            trigger: "change",
          },
        ],
        personType: [
          { required: true, message: this.$i18n.t("称谓"), trigger: "change" },
        ],
        companyName: [
          {
            required: true,
            message: this.$i18n.t("公司名称"),
            trigger: "change",
          },
        ],
        companyType: [
          {
            required: true,
            message: this.$i18n.t("公司类型"),
            trigger: "change",
          },
        ],
        personJob: [
          { required: true, message: this.$i18n.t("职务"), trigger: "change" },
        ],
        phone: [
          { required: true, message: this.$i18n.t("手机"), trigger: "change" },
        ],
        email: [
          {
            required: true,
            message: this.$i18n.t("E-mail"),
            trigger: "change",
          },
        ],
        tel: [
          { required: true, message: this.$i18n.t("电话"), trigger: "change" },
        ],
        url: [
          { required: false, message: this.$i18n.t("网址"), trigger: "change" },
        ],
        interestedIds: [
          {
            required: true,
            message: this.$i18n.t("感兴趣的展区"),
            trigger: "change",
            validator: (rule, value, callback) => {
              if (this.interestedIds == "") {
                callback(new Error(this.$i18n.t("感兴趣的展区")));
              } else {
                callback();
              }
            },
          },
        ],
      },
      companyTypes: [
        { name: this.$i18n.t("工厂"), value: "1" },
        { name: this.$i18n.t("汽配品牌商"), value: "2" },
        { name: this.$i18n.t("维修厂/连锁"), value: "3" },
        { name: this.$i18n.t("其他"), value: "4" },
      ],
      interestedIds: [],
    };
  },
  watch: {
    showDetail(val) {},
  },
  mounted() {
    window.scrollTo(0, 630); // 页面加载后，滚动到300px的位置
  },
  created() {
    this.getList();
  },
  methods: {
    interestedIdsChange(e) {
      this.form.interestedIds = e ? e.join(",") : "";
    },
    async getList() {
      var { list, total } = (await activelist({ status: 2 })).data;
      if (list.length < 1) {
        let data = (await activelist({ status: 3 })).data;
        list = data.list;
        total = data.list;
      }
      this.form.activityInfoId = list[0].id || "";
      this.activelist = list;
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          subapply(this.form)
            .then((res) => {
              this.$message({
                message: "申请成功!",
                type: "success",
              });
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        } else {
          return false;
        }
      });
    },
    handleChangeSize(value) {
      this.pageSize = value;
      this.search.pageSize = value;
      this.handleSearch();
    },
    handleReset() {
      Object.entries(this.search).forEach(([key, value]) => {
        console.log([key, value]);
      });
      Object.keys(this.search).forEach((key) => {
        this.search[key] = "";
      });
      this.search.categoryFirstSup = [];
      this.search.manufacturerCname = [];
      this.handleSearch();
    },
    // 查询数据
    handleSearch(currentPage = 1) {
      this.currentPage = currentPage;
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.search,
          currentPage,
        },
      });
      this.productsList({ ...this.search, currentPage });
    },
    /** 跳转详情 */
    gotoDetail(id) {
      this.$router.push({
        path: "/shopDetail",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #fff;

  > h1 {
    color: #1b2d71;
    font-weight: 600;
    border-bottom: #1b2d71 5px solid;
  }

  .head {
    .head-enter {
      position: absolute;
      bottom: 15px;
      left: 0;
      display: flex;
      width: 100%;
      justify-content: space-between;

      div {
        color: #fff;
        line-height: 90px;
        text-align: center;
        cursor: pointer;
        font-size: 20px;
        width: 290px;
        height: 90px;
        background-color: #0f6ab3;
        // border: 1px solid red;
        i {
          font-size: 38px;
          vertical-align: sub;
          margin-top: 10px;
          margin-right: 20px;
        }
      }
    }
  }

  .el-tabs__item {
    height: 65px;
    line-height: 65px;
  }
  .el-radio-group {
    // display: flex;
    // flex-wrap: nowrap;
  }
}
</style>